var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExercisesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.23,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D0D8DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2420_14017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1067 11.0909C29.7497 10.418 29.0432 10.0005 28.2624 10.0005H22.0002C20.837 10.0005 19.8908 10.9467 19.8908 12.1098V14.9223C19.8908 16.0854 20.837 17.0316 22.0002 17.0316H24.1095V14.2192H23.4064C23.0178 14.2192 22.7033 13.9047 22.7033 13.5161C22.7033 13.1274 23.0178 12.8129 23.4064 12.8129H24.8595C25.2481 12.8129 25.5626 13.1274 25.5626 13.5161V17.0316H26.2657C26.6537 17.0316 26.9688 17.3468 26.9688 17.7347V23.3258C27.7981 23.5521 28.6135 23.8411 29.3926 24.2306C29.7401 24.4044 29.8808 24.8266 29.7071 25.1741C29.5361 25.5171 29.116 25.6635 28.7637 25.4886C25.439 23.8255 21.4207 23.8255 18.096 25.4886C17.7486 25.6609 17.3256 25.5215 17.1525 25.1741C16.9788 24.8266 17.1196 24.4044 17.467 24.2306C18.5196 23.7043 19.6327 23.344 20.7682 23.1156C19.1707 21.5862 16.9515 20.9987 14.7562 21.548C12.5281 22.1049 10.7007 23.91 10.1728 26.1498C9.72299 28.0896 10.1611 30.0774 11.3744 31.6044C12.5842 33.1267 14.4369 34.0001 16.3753 34.0001C22.8578 34.0001 28.2159 32.4377 33.6127 29.7065C33.8502 29.587 34 29.344 34 29.0783V26.0269C34 20.8099 32.6507 15.578 30.1067 11.0909Z",
    fill: "#2F80ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2420_14017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercisesIcon);
export default __webpack_public_path__ + "static/media/ExercisesIcon.1b01d38bda7df4893d63e73cd60827e7.svg";
export { ForwardRef as ReactComponent };